import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

function deferTelemetryBootstrap() {
  const run = () => {
    void Promise.all([import("./lib/errorTracking"), import("./lib/metrics")]).then(
      ([{ initDashboardErrorTracking }, { initDashboardMetrics }]) => {
        initDashboardErrorTracking();
        initDashboardMetrics();
      },
    );
  };
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    window.setTimeout(run, 1200);
  }
}

deferTelemetryBootstrap();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
